import React, { Component } from 'react';
import $ from 'jquery';
import jQuery from 'jquery';

import AdminLayout from './layout';

import FetchCall from '../../API/FetchCall';

//import { Editor } from '@tinymce/tinymce-react';
import { getLeads, getTotalLeads, getLeadsByPartner, removelead, getLead_Stats, getIncompleteLeads } from '../../API/FetchCall';

import Pagination from "react-js-pagination";
//import Pagination from 'rc-pagination';

import BeWiseLoading from '../../../src/assets/bewiseloading.gif';

class leadList extends Component {

    constructor(props) {
        super(props);
        var url = new URL(window.location.href);
        var location = url.searchParams.get("location");
        var auth_data = JSON.parse(localStorage.getItem("user_data"));
        this.state = {
              logged: localStorage.getItem("authentication"),
              auth_data: JSON.parse(localStorage.getItem("user_data")),
              location: location ? location : (auth_data.access_location ? auth_data.access_location : 'Bengaluru'),
              PER_PAGE:15,
              total:0,
              loading:true,
              searchby:'',
              activePage:0,
              offset:0,
              leads: [{ name: "", 
                  enddate : "",
                  fromdate : "",
                  starttime : "",
                  feeinr : "",
                  feeusd : "",
                  duration : "",
                  days : "" }],
        };

    }

    getTotal = (vertical, location='') => {

      const { login_id, role } = this.state.auth_data;

      const locationselected = (location=='')?this.state.location:location;

      let ins = JSON.stringify({
        vendor_id: login_id,
        role: role,
        vertical: vertical,
        location: locationselected,
        searchby:this.state.searchby,
      });

      getTotalLeads(ins).then((res) => {


        this.setState({loading:true});

        if (res.status == 1) {

                  
          this.setState({
            
            total: res.total
            
          });

        } 
      });
    }  

    componentDidMount() {

      let dataOfUser = this.state.auth_data;

      let allowedtoacess = (dataOfUser.upgraded==1)?true:(dataOfUser.current_plan!=5 && dataOfUser.current_plan!=0  && dataOfUser.current_plan!=1)?true:false;
      this.setState({allowedtoacess:allowedtoacess});


      var THIS = this;
      $(document).on('click', '.remove_maili', function () {
        var delete_id = $(this).data("id");
        THIS.setState({
          delete_id: delete_id
        })
      });
      
      this.getTotal('leads');
      this.getList();
    }


    getList = (pageNumber=1, location='') => {

      const { login_id, role } = this.state.auth_data;
      
      this.setState({activePage: pageNumber});

      const newOffset = (pageNumber==1)? 0 : (((pageNumber-1) * this.state.PER_PAGE)%this.state.total);

      const locationselected = (location=='')?this.state.location:location;

      let ins = JSON.stringify({
        vendor_id: login_id,
        role: role,
        location: locationselected,
        searchby:this.state.searchby,
        perpage:this.state.PER_PAGE,
        year: this.state.year,
        month: this.state.month,
        offset:newOffset
      });

      getLeads(ins).then((res) => {

        this.setState({loading:true});

        if (res.status == 1) {

          this.setState({loading:!this.state.loading});
          

            const newLeads = res.leads.map((lead) => ({
                "id": lead.id,
                "firstname": lead.firstname,
                "lastname": lead.lastname,
                "vertical": lead.lead_vertical,
                "searchkey": lead.searchkey,
                "location": lead.location,
                "city" : lead.city,
                "mobilenumber": lead.mobilenumber,
                "ispartnersent":lead.ispartnersent,
                "status":lead.lead_status,
                "email": lead.email,
                "createdAt": new Intl.DateTimeFormat('en-US', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' }).format(lead.created_date)
            }));

            this.setState({ leads: newLeads});


        } else {

              this.setState({loading:!this.state.loading});
              
              this.setState({
                leads: [],
              });
        }
      });


    }      

    handlePageChange(pageNumber) {

          console.log(`active page is ${pageNumber}`);

          this.setState({activePage: pageNumber});

          //this.getTotal('bw_schools');
          this.getList(pageNumber);


    }       

    openDetail(id){
            window.location='/leads/leadDetail/'+id;
    } 
    remove(id){

            let toastr = '';
            jQuery(this).attr('disabled', false);

            toastr = window.toastr.error; //warning
            toastr('Success', 'Lead is removed', {
                positionClass: "toast-bottom-right",
                containerId: "toast-bottom-right"
            });
        
    } 

     discard(id){

        if(confirm("Are you sure you want to delete this lead?")){

            let toastr = '';
            jQuery(this).attr('disabled', false);


            let req = JSON.stringify({
              lead_id: id
            });

            removelead(req).then((res) => {

                this.leadList();

                toastr = window.toastr.error; //warning
                toastr('Success', 'Lead is discarded', {
                        positionClass: "toast-bottom-right",
                        containerId: "toast-bottom-right"
                });

            });
        
        
        }
    } 

    render() {

        const { leads } = this.state;
        const { currentPage, PER_PAGE, totalCount, total, allowedtoacess} = this.state;

        return (
            <React.Fragment>
                <AdminLayout>

                
                    
           <div class="col-lg-12 grid-margin stretch-card">
              <div class="card">
                <div class="card-body">
                  <h4 class="card-title">Leads</h4>
                 <div class="middlesection">
                  {!allowedtoacess && 
                    <div class="overlay"><span>Please subscribe or upgrade</span></div>
                  }
                  <div className={ !allowedtoacess ? "table-responsive pt-3 blurred": "table-responsive pt-3" }>
                     <table class="table table-bordered table-sm">
                      <thead  class="thead-dark">
                        <tr>
                         
                          <th>S.No</th>
                          <th>First Name</th>
                          <th>Last Name</th>
                          <th>Date</th>
                          <th>Vertical</th>
                          <th>City</th>
                          <th>Sent Partner Info?</th>
                          <th>Action</th>
                         
                     
                          
                        </tr>
                      </thead>
                      <tbody>
                      {leads.length>0 && leads.map((lead, i) => {     
                      
                       return <tr>
                          <td>
                            {i+1}
                          </td>
                                                    
                          <td>{lead.firstname}</td>
                          <td>{lead.lastname}</td>
                          <td>{lead.createdAt}</td>
                          <td>{lead.vertical}</td>
                          <td>{lead.city}</td>
                          <td dangerouslySetInnerHTML={{__html:lead.ispartnersent}}></td>
                          <td>
                            <span class="cursorpointer" onClick={()=>this.openDetail(lead.id)}><i class="eye-button fa fa-eye" title="View"></i></span>&nbsp;&nbsp;&nbsp;&nbsp;
                            <span class="cursorpointer" onClick={()=>this.discard(lead.id)}><i class="fa fa-trash" title="Trash"></i></span>
                                          
                          </td> 

                        </tr>

                      })

                      }

                      {leads.length==0 && 

                      <tr><td colSpan="6">No data</td></tr>
                       }
                       
                      </tbody>
                    </table>


                    <div class="text-center">
                      
                     <Pagination
                        activePage={this.state.activePage}
                        itemsCountPerPage={PER_PAGE}
                        totalItemsCount={this.state.total}
                        pageRangeDisplayed={5}
                        activeClass={"pagination__link--active"}
                        onChange={this.handlePageChange.bind(this)}
                        prevPageText="previous"
                        nextPageText="next"
                      />

                    </div>

                  </div>
                 </div> 
                </div>
              </div>
            </div>

                </AdminLayout>
            </React.Fragment>
        )
    }
}


export default leadList;


// WEBPACK FOOTER //
// ./src/components/bewise/leadList.jsx